
import 'babel-polyfill'
import { getHeaderNavInfo } from 'js/api/header'
import { headerNavJson } from 'js/config/header-nav'
import country from 'js/libs/country.js'
import * as userApi from 'js/api/user'
import { toThousands, appendIframe, getQueryString, setQueryString } from 'js/libs/utils'
import { layer } from 'js/libs/utils-layer'
import { config } from 'config'
import SSO from 'js/libs/sso/sso'
import { Base64 } from 'js-base64'
// import { getHtml as getUserHtml } from 'js/libs/utils-login-html'
import GetUserHtml from 'js/libs/utils-login-html'
let userinfoJson = {} // 提升为全局变量
const userInfoModal = new GetUserHtml()

// 统一登陆老系统下需要再次发送一个请求用于登陆
function ssoLoginForOldSystem () {
  appendIframe(`${config.API}api/ajaxLogin`)
}

// 宙斯老页面挑战门户首页登录
function judgeZenusLogin () {
  if (getQueryString('jump') === 'login') {
    showLoginModal()
  }
}

function renderUserinfo () {
  userApi.getUserinfo().then(function (result) {
    if (result.code === '0' || result.code === 0) {
      // 统一登陆老系统下需要再次发送一个请求用于登陆
      ssoLoginForOldSystem()
      let userinfo = result.data

      switch (userinfo.certificateType) {
        case 'PERSONAL': {
          userinfoJson.certificate = '个人认证'
          break
        }
        case 'STUDENT': {
          userinfoJson.certificate = '学生认证'
          break
        }
        case 'BUSINESS_TEAM': {
          userinfoJson.certificate = '创业团队认证'
          break
        }
        case 'COMPANY': {
          userinfoJson.certificate = '企业认证'
          break
        }
        default: {
          userinfoJson.certificate = '未实名认证'
        }
      }
      if (userinfo.certificateStatus === null) {
        var comRegTime = ''
        var comToday = ''
        var registrationTime = userinfo.registrationTime
        var regTime = new Date(registrationTime).toLocaleDateString()
        if (regTime.length < 15) {
          if (window.ActiveXObject) {
            comRegTime = regTime.replace(/([\d]{4})[\s\S]{1}([\d]{1,2})[\s\S]{1}([\d]{1,2})[\s\S]{1}/, '$1/$2/$3')
          } else {
            comRegTime = regTime
          }
        } else {
          comRegTime = regTime.replace(/[\s\S]{1}([\d]{4})[\s\S]{3}([\d]{1,2})[\s\S]{3}([\d]{1,2})[\s\S]{2}/, '$1/$2/$3')
        }
        var today = new Date().toLocaleDateString()
        if (today.length < 15) {
          if (window.ActiveXObject) {
            comToday = today.replace(/([\d]{4})[\s\S]{1}([\d]{1,2})[\s\S]{1}([\d]{1,2})[\s\S]{1}/, '$1/$2/$3')
          } else {
            comToday = today
          }
        } else {
          comToday = today.replace(/[\s\S]{1}([\d]{4})[\s\S]{3}([\d]{1,2})[\s\S]{3}([\d]{1,2})[\s\S]{2}/, '$1/$2/$3')
        }
      }
      if (userinfo.certificateType) {
        switch (userinfo.certificateStatus) {
          case 0:
          case '0': {
            userinfoJson.certificate = '实名认证未通过'
            break
          }
          case 2:
          case '2': {
            userinfoJson.certificate = '实名认证审核中'
            break
          }
        }
      }
      if (userinfo.certificateType) {
        userinfoJson.toCertificate = `${config.CONSOLE}user/authentication`
        if (userinfo.certificateStatus != 0 && userinfo.certificateStatus != 2) { // eslint-disable-line
          userinfoJson.certificateClass = 'certificated'
        }
      } else {
        userinfoJson.toCertificate = `${config.CONSOLE}user/authentication`
        userinfoJson.certificateClass = ''
      }
      userinfoJson.userName = userinfo.nickname || userinfo.email || userinfo.login
      userinfoJson.email = userinfo.email
      userinfoJson.certificateType = userinfo.certificateType
      userinfoJson.balance = userinfo.balance + ''
      let balanceLength = userinfoJson.balance.length
      userinfoJson.balance =
        toThousands(userinfoJson.balance.substr(0, balanceLength - 2)) +
        '.' +
        userinfoJson.balance.substr(balanceLength - 2, balanceLength)
      var html = userInfoModal.renderHtml(userinfoJson)
      $('.top-nav-list').css('margin-right', '230px')
      $('.header-right').append(html).find('.register').remove()
      $('.header-right').find('.quick-login').remove()
    } else {
      judgeZenusLogin()
    }
  })
}
renderUserinfo()

var headerJson = headerNavJson

getHeaderNavInfo().then(result => {
  if (result.code === 0 || result.code === '0') {
    headerJson = JSON.parse(result.data.header)
    var commonData = JSON.parse(result.data.common)
    $('.header-left .citylogo').attr('src', commonData.xfyunPCLogo)
    $('.header-left .tjCenter').attr('src', commonData.pcLogo)
    renderHeader()
  }
})

function renderHeader () {
  var headerNavHtml = ''
  headerJson && headerJson.forEach((item) => {
    headerNavHtml += `
      <li class='nav-list nav-drop'>
        <div class='nav-list-inner nli-services nli-multiple'>`
    if (item.path) {
      headerNavHtml += `
          <a href='${item.path}' target='${item.target ? item.target : '_blank'}'>
            <span>${item.title}</span>
          </a>`
    } else {
      headerNavHtml += `
          <a>
            <span>${item.title}</span>
          </a>`
    }
    headerNavHtml += `</div>`
    if (item.items) {
      headerNavHtml += `<div class="second-menu expand">
      <div class="second-menu-container">`
      item.items.forEach((block) => {
        headerNavHtml += `<div class="second-menu-item">`
        if (block.path) {
          headerNavHtml += `<a class="menu-title-link" href='${block.path}' target='${block.target ? block.target : '_blank'}' rel="noreferrer">${block.title}</a>`
        } else {
          headerNavHtml += `<h2 class="menu-title">${block.title}</h2>`
        }
        headerNavHtml += `<ul class="second-menu-list">`
        block.items && block.items.forEach((list) => {
          headerNavHtml += `
                  <li>
                    <a href='${list.path}' target='${list.target ? list.target : '_blank'}' rel="noreferrer">
                      <apan>${list.title}</apan>`
          if (list.badge) {
            headerNavHtml += `<img class="badge" src='${list.badge}' />`
          }
          headerNavHtml += `
                    </a>
                  </li>`
        })
        headerNavHtml += `</ul>
              </div>`
      })
      headerNavHtml += `</div>
          </div>
        </li>
      `
    } else {
      headerNavHtml += `
        </li>
      `
    }
  })
  $('.header .header-nav').append(headerNavHtml)
}

(function () {
  var formObj = { // 表单参数
    userName: '', // 姓名
    userContact: '', // 手机号
    desc: '', // 需求描述
    countryCode: '+86' // 国别码
  }

  var countryList = country.countryList
  var tempRes = ''
  for (let i = 0; i < countryList.length; i++) {
    tempRes += '<option value="+' + countryList[i][1] + '">' + '+(' + countryList[i][1] + ')' + countryList[i][2] + '</option>'
  }

  if ($('.ipt.select')[0]) {
    $('.ipt.select')[0].innerHTML = tempRes
  }

  if (window.location.search.includes('isFb=1')) {
    var pathname = window.location.pathname
    window.history.replaceState({}, '', pathname)
    $('.select')[0][0].selected = true
    $('.cor.phone').hide()
    $('.ipt.userName')[0].value = ''
    $('.ipt.textarea')[0].value = ''
    userApi.getUserinfo().then(result => { $('.ipt.phone')[0].value = result.data.mobile })
    userApi.getUserinfo().then(result => { formObj.userContact = result.data.mobile })
    $('.feedback').show()
  }

  // 点击展示弹窗
  $('.feedback-btn').click(function () {
    userApi.getUserinfo().then(result => {
      if (result.code === 80000) {
        const jumpBack =
        Base64.encode(setQueryString('isFb', 1))
        window.location.href = `${config.PASSPORT_NEW}login?jump=${jumpBack}`
      } else {
        $('.select')[0][0].selected = true
        $('.cor.phone').hide()
        $('.ipt.userName')[0].value = ''
        $('.ipt.textarea')[0].value = ''
        $('.submit-btn').removeClass('fill')
        userApi.getUserinfo().then(result => { $('.ipt.phone')[0].value = result.data.mobile })
        userApi.getUserinfo().then(result => { formObj.userContact = result.data.mobile })
        $('.feedback').show()
      }
    })
  })

  function unshow () {
    $('.feedback').hide()
    $('.feedback-success').hide()
  }
  // 监听称呼回调
  $('.ipt.userName').on('input propertychange', function () {
    formObj.userName = this.value
    isFill()
    $('.req.name').hide()
    if (this.value === '') {
      $('.req.name').show()
    }
  })
  // 监听国别码select
  $('.ipt.select').change(function () {
    formObj.countryCode = this.value
  })

  // 监听手机号码
  $('.ipt.phone').on('input propertychange', function () {
    formObj.userContact = this.value
    isFill()
    $('.req.phone').hide()
    $('.cor.phone').hide()
    if (this.value === '') {
      $('.req.phone').show()
      $('.cor.phone').hide()
    } else if ($('.ipt.select')[0].value === '+86' && !/^[1][3|4|5|6|7|8|9][0-9]{9}$/.test(this.value)) {
      $('.cor.phone').show()
    } else if ($('.ipt.select')[0].value !== '+86' && !/^[0-9]{5,20}$/.test(this.value)) {
      $('.cor.phone').show()
    }
  })

  // 监听意见
  $('.ipt.textarea').on('input propertychange', function () {
    formObj.desc = this.value
    isFill()
    $('.req.advice').hide()
    if (this.value === '') {
      $('.req.advice').show()
    }
  })

  $('.feedback-close').click(function () {
    unshow()
  })

  $('.feedback-success-close').click(function () {
    unshow()
  })

  // input是否输入完全
  function isFill () {
    var phonenumber = $('.ipt.phone')[0].value
    if ($('.ipt.userName')[0].value !== '' && $('.ipt.textarea')[0].value !== '') {
      if ($('.ipt.select')[0].value === '+86' && !/^[1][3|4|5|6|7|8|9][0-9]{9}$/.test(phonenumber)) {
        $('.submit-btn').removeClass('fill')
      } else if ($('.ipt.select')[0].value !== '+86' && !/^[0-9]{5,20}$/.test(phonenumber)) {
        $('.submit-btn').removeClass('fill')
      } else {
        $('.submit-btn').addClass('fill')
      }
    } else {
      $('.submit-btn').removeClass('fill')
    }
  }

  $('.submit-btn').click(function () {
    console.log(formObj)
    $.ajax({
      url: '/herapi/feedback/add',
      type: 'post',
      dataType: 'json',
      data: JSON.stringify(formObj),
      cache: false,
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      success: function (data) {
        console.log(data)
        if (data.code !== 0) {
          jAlert(data.desc || '提交失败')
          return
        }
        $('.feedback').hide()
        $('.feedback-success').show()
        $('.ipt.userName')[0].value = ''
        $('.ipt.textarea')[0].value = ''
        $('.select')[0][0].selected = true
      },
      error: function (err) {
        console.log(err)
      }
    })
  })
})()



// WEBPACK FOOTER //
// ./src/js/libs/utils-header-sidebar.js